import React, { type FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  CopyClipboard,
  TextButton,
  type TextButtonSkin,
} from '@wix/design-system';
import { DuplicateSmall } from '@wix/wix-ui-icons-common';
import { DataHooks } from '../../constants/dataHooks';
import { useTemplatesPageBi } from '../../hooks/useTemplatesPageBi';
import { useTemplatesData } from '../../hooks/useTemplatesData';

type Props = {
  dataHook?: string;
  valueToCopy: string;
  origin: string;
  skin?: TextButtonSkin;
  onCopyClick?: () => void;
};
export const CopyCodeToClipboard: FC<Props> = ({
  dataHook,
  valueToCopy,
  skin,
  origin,
  onCopyClick,
}) => {
  const { t } = useTranslation();
  const { currentTemplate: template } = useTemplatesData();

  const { reportCopyToClipboardClicked } = useTemplatesPageBi();
  const duplicateIcon =
    origin === 'markdown-codeblock'
      ? { prefixIcon: <DuplicateSmall /> }
      : { suffixIcon: <DuplicateSmall /> };

  return (
    <CopyClipboard dataHook={dataHook} value={valueToCopy} resetTimeout={1500}>
      {({ isCopied, copyToClipboard }) => (
        <TextButton
          dataHook={DataHooks.CodeBlockCopyToClipboardTextButton}
          size="small"
          weight="thin"
          skin={skin || 'standard'}
          onClick={() => {
            reportCopyToClipboardClicked(template.id, origin);
            onCopyClick?.();
            copyToClipboard();
          }}
          {...duplicateIcon}
        >
          {t(
            `app.template-page.modal.terminal.tooltip.${
              isCopied ? 'copied' : 'copy'
            }`,
          )}
        </TextButton>
      )}
    </CopyClipboard>
  );
};
